import { render } from "./MLight.vue?vue&type=template&id=249cd998&scoped=true"
import script from "./MLight.vue?vue&type=script&lang=js"
export * from "./MLight.vue?vue&type=script&lang=js"

import "./MLight.vue?vue&type=style&index=0&id=249cd998&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-249cd998"]])

export default __exports__